import { createContext, useContext } from "react";



export const AuthContext = createContext({
  userInfo: {},
  permissions: [],
  login: () => { },
  isAuthenticated: false,
  logout: () => { },
  setThePermissions: () => { },
  paymentMethods: [],
  getPaymentMethods: () => { },


});

export const useAuth = () => useContext(AuthContext);
